import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import sdk from '../script';
import Map from './Map';
import Sidebar from './Sidebar';
import Statistics from './Statistics';
import commons from '../script/utils/commons';
import '../style/ui.css';
import './AppContainer.css';
import DialogConfirmation from "./Dialog/confirmation";
import { i18n_get_value, I18N_LABELS } from '../i18n/i18n_scripts';

import OrdersDetails from './Sidebar/orders-list/orders-details';
import { getAllOrders } from './data/actions/orders';
import { getAllDrivers } from './data/actions/drivers';
import { getAllScheduled } from './data/actions/scheduled';
import { getStoreData, resetStatistics, removeAlarm } from './data/actions/store';
import { WebSocketContext } from './websocket/websocket';

export class AppContainer extends Component {
    static contextType = WebSocketContext;

    constructor(props) {
        super(props);
        this.state = {
            isSignedIn: false,
            map: { orderSelected: null },
            login: {
                user: commons.getLoginUser(),
                storeId: commons.getLoginStoreId(),
            },
        }
    }

    componentDidMount() {
        this.context.init();
        const statisticsStartDate = window.localStorage.getItem('statisticsStartDate');
        // TODO improve differentiation between different error cases

        if (!('user' in commons.getSession())) {
            this.redirectRoute('/unauthorised');
            return;
        }

        sdk.store.getStoreInfo(this.state.login.storeId, {
            statisticsFrom: statisticsStartDate && moment().diff(moment(statisticsStartDate), 'hours') <= 3 ? null : null,
        })
            .then(store => {
                // updatade store reducer
                this.setState(prevState => { return { isSignedIn: !prevState.isSignedIn } }, () => {
                    this.props.getStoreData(store);
                    this.props.getAllDrivers(store.drivers)
                    this.props.getAllOrders(store.orders)
                    this.props.getAllScheduled(store.scheduled)
                })


            }).catch(err => {
                console.error(err);
                this.setState({ isSignedIn: false });

                this.redirectRoute('/unauthorised');
            });
    }

    resetStatistics() {
        window.localStorage.setItem('statisticsStartDate', moment().format('YYYY-MM-DD[T]HH:mm:ss[.]SSSZZ'));
        this.props.resetStatistics();
    }

    render() {

        let highlightedOrder;

        if(!this.props.orders || this.props.orders.orders.length === 0) {
            highlightedOrder = null;
        } else {
            highlightedOrder = this.props.orders.order.highlighted
        }
        
        const selectedDriver = highlightedOrder && highlightedOrder.driverId

        return (
            this.state.isSignedIn ? (
                <div id="app">
                    <div className={"map-wrapper no-animation"}>

                        <Map
                            orders={this.props.orders}
                            store={this.props.store}
                            driver={this.props.drivers.driver}
                            drivers={this.props.drivers.drivers.filter(driver => this.props.drivers.driver.filter[driver.status])}
                            center={{ lat: this.props.store.lat, lng: this.props.store.lng }}
                            zoom={14}
                        />
                        <Sidebar
                            storeName={this.props.store.name}
                            orders={this.props.orders}
                            drivers={this.props.drivers}
                            scheduled={this.props.scheduled}
                            statusFilter={this.props.drivers.driver.filter}
                            selectedDriver={selectedDriver}
                        />
                        <Statistics
                            scheduled={this.props.store.scheduled}
                            avgPreparationTime={this.props.store.avgPreparationTime}
                            avgDispatchTime={this.props.store.avgDispatchTime}
                            avgStoreTime={this.props.store.avgStoreTime}
                            avgDrivingTime={this.props.store.avgDrivingTime}
                            avgDeliveryTime={this.props.store.avgDeliveryTime}
                            avgRating={this.props.store.avgRating}
                            expectedDeliveryTime={this.props.store.expectedDeliveryTime}
                            onReset={this.resetStatistics}
                        />

                        <OrdersDetails
                            orders={this.props.orders}
                            order={highlightedOrder}
                            drivers={this.props.drivers.drivers}
                        />

                    </div>
                    {this.props.store.alarms && this.props.store.alarms[0] && (
                        <div className="page-wrap">
                            <div className="container">
                                <div className="message animated bounceIn">
                                    <div className="display-table">
                                        <div className="display-table-cell modal-warning">
                                            <div className="modal-warning-header">
                                                <h2>{i18n_get_value(I18N_LABELS.DRIVER_IN_DANGER_NAME)}</h2>
                                            </div>
                                            <div className="modal-warning-body">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>{i18n_get_value(I18N_LABELS.DRIVER_IN_DANGER_ALARM_ID_LABEL)}:</td>
                                                            <td>{this.props.store.alarms[0].id}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{i18n_get_value(I18N_LABELS.DRIVER_IN_DANGER_DRIVER_NAME_LABEL)}:</td>
                                                            <td>{this.props.store.alarms[0].driverName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{i18n_get_value(I18N_LABELS.DRIVER_IN_DANGER_DRIVER_LOCATION)}:</td>
                                                            <td>{this.props.store.alarms[0].location.lat + ", " + this.props.store.alarms[0].location.lng}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="modal-warning-footer">
                                                <button id="btn_alarm_close" onClick={() => {
                                                    this.closePanicDialog(this.props.store.alarms[0])
                                                }}>{i18n_get_value(I18N_LABELS.DRIVER_IN_DANGER_CLOSE_BUTTON)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    <DialogConfirmation
                        isSignedIn={this.state.isSignedIn}
                        scheduled={this.props.scheduled}
                    />
                </div>
            )
                :
                <div className="page-wrap">
                    <div className="container">
                        <div className="message animated bounceIn">
                            <div className="display-table">
                                <div className="display-table-cell">
                                    <h2>{i18n_get_value(I18N_LABELS.LOADING_MESSAGE)}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }


    closePanicDialog(alarm) {
        if (alarm === undefined || alarm === null) {
            return;
        }
        sdk.store.closeDriverAlarm(alarm);
        this.props.removeAlarm();
    }


    redirectRoute(location) {
        if (this.props.history) {
            this.props.history.push(location)
        } else {
            console.error("No history available to redirect to route location: " + location);
        }
    }

}

const mapDispatchToProps = {
    getAllOrders,
    getAllDrivers,
    getAllScheduled,
    getStoreData,
    resetStatistics,
    removeAlarm,
}

const mapStateToProps = ({ orders, drivers, scheduled, store }) => ({
    orders,
    drivers,
    scheduled,
    store,
});


export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
